import { DAPI_HOST } from '../../config';
import { apiPostJson } from './index';
import logger from '../logger';
import fetch from 'isomorphic-fetch';

const getImageUploadFilename = () => `${DAPI_HOST}/v3/images`;

const getS3SigningUrl = (name, type) => {
  const n = encodeURIComponent(name);
  const t = encodeURIComponent(type);
  return `/sign-s3?file-name=${n}&file-type=${t}`;
};

const s3SignedUrl = ({ name, type }) =>
  fetch(getS3SigningUrl(name, type), {
    method: 'GET',
    headers: {
      'Content-Type': type,
    },
  }).then(res => res.json());

const putToS3 = (url, { image, type, contentDisposition = 'insurance.jpg' }) =>
  fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': type,
      'x-amz-server-side-encryption': 'AES256',
      'Content-Disposition': contentDisposition,
    },
    body: image,
  });

const uploadToS3 = image => {
  const onSigningSuccess = response => {
    const uploadUrl = response.signedRequest;
    const headers = {
      'Content-Type': image.type,
      'x-amz-server-side-encryption': 'AES256',
      'Content-Disposition': 'insurance.jpg',
    };

    fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': image.type,
        'x-amz-server-side-encryption': 'AES256',
        'Content-Disposition': 'insurance.jpg',
      },
      body: image.image,
    })
      .then(() => logger.debug('S3 upload success'))
      .catch(e => logger.error(e));
  };

  const onSigningFailure = response => {
    logger.error(response);
  };

  fetch(getS3SigningUrl(image.name, image.type), {
    method: 'GET',
    headers: {
      'Content-Type': image.type,
    },
  })
    .then(res => res.json().then(json => onSigningSuccess(json)))
    .catch(onSigningFailure);
};

const uploadInsuranceImage = (
  image,
  imageType,
  insuranceProfileId,
  ocrResponse,
  onSuccess,
  onFailure
) => {
  const handleFilenameSuccess = response => {
    onSuccess(response);
    uploadToS3({ ...image, name: response.data.aws_path });
  };

  apiPostJson(getImageUploadFilename(), {
    image_type: imageType,
    ocr_response: {},
    insurance_profile_id: insuranceProfileId,
  })
    .then(handleFilenameSuccess)
    .catch(onFailure);
};

export { uploadInsuranceImage, s3SignedUrl, getS3SigningUrl, getImageUploadFilename, putToS3 };
